<template>
  <div class="appNav-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="页面跳转设置" name="1">
          <div class="setting-item">请绑定单元格的跳转链接</div>
          <div class="setting-item clearFloat mt8 changeUrlItem" v-for="(uid, index) in allColsUid" :key="uid">
            <div class="mr4">{{ "单元格" + (index + 1) }}</div>
            <div :data-len="'len' + allCols[uid].componentBoxOptions.routerLinkUrl.length">
              <el-input
                :value="allCols[uid].componentBoxOptions.routerLinkUrl"
                placeholder="请输入跳转链接"
                @focus="focusInput(uid, $event)"
                @blur="blurInput(uid, $event)"
                @input="updateLinkUrl(uid, $event)"
              ></el-input>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { getAllElementsInColsInLayoutComponent } from "utils"
import qs from "qs"
export default {
  name: "appNav-options-data",
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      countCol: 1
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    allColsUid() {
      return Object.keys(this.allCols)
    },
    allCols() {
      return getAllElementsInColsInLayoutComponent(this.options.rows)
    }
  },
  methods: {
    focusInput(uid, e) {
      document.getElementById("componentBox_after" + uid).style.border = "1px solid red"
    },
    blurInput(uid, e) {
      document.getElementById("componentBox_after" + uid).style.border = "none"
    },
    updateLinkUrl(uid, url) {
      const param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        uid,
        option_val: url,
        option_name: "componentBoxOptions-routerLinkUrl"
      }
      // http://mh.chaoxing.com/mhssr/?p=dfb4320044fa5111ed0954d17f45dd6d4ff7&a=1&v=19#/
      this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
      if (url.includes("/v2/p/") && !window.isBigScreenPreviewUrl) {
        const p = url.slice(url.indexOf("/p/") + 3, url.includes("#/") ? -2 : url.length - 1)
        if (!p) return
        const param2 = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid,
          option_val: p,
          option_name: "componentBoxOptions-routerLinkPageId"
        }
        console.log(qs.parse(url))
        this.$store.dispatch(this.request_prefix + "/updateColsOption", param2)
      } else {
        const param2 = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid,
          option_val: "none",
          option_name: "componentBoxOptions-routerLinkPageId"
        }
        console.log(qs.parse(url))
        this.$store.dispatch(this.request_prefix + "/updateColsOption", param2)
      }
    }
  }
}
</script>

<style scoped >
.changeUrlItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
